import { Box, TextField } from "@mui/material";
import { DesktopTimePicker } from "@mui/x-date-pickers";
import { DurationSelectType } from "apps/web/src/componentLibrary/DurationSelect/FormSchema";
import { TWTabGroup } from "apps/web/src/componentLibrary/TWTabGroup/TWTabGroup";
import ActivityTypeSelect from "apps/web/src/components/Activity/TypeSelect";
import MealTypeSelect from "apps/web/src/components/Meal/TypeSelect";
import { ActivityType, MealType } from "apps/web/src/types";
import { Control, Controller, FieldErrors } from "react-hook-form";

export const MEAL = "Meal";
export const ACTIVITY = "Activity";
export const NEW_EVENT_TABS = [MEAL, ACTIVITY];

interface NewEventFormFieldsProps {
  selectedTab: string;
  onSelectedTab: (tab: string) => void;
  eventName: string;
  onEventNameChange: (name: string) => void;
  mealType: MealType;
  onMealTypeChange: (type: MealType) => void;
  activityType: ActivityType;
  onActivityTypeChange: (type: ActivityType) => void;
  control: Control<DurationSelectType>;
  errors: FieldErrors<DurationSelectType>;
}

export const NewEventFormFields = ({
  selectedTab,
  onSelectedTab,
  eventName,
  onEventNameChange,
  mealType,
  onMealTypeChange,
  activityType,
  onActivityTypeChange,
  control,
  errors,
}: NewEventFormFieldsProps) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <TWTabGroup tabs={NEW_EVENT_TABS} onSelected={onSelectedTab} outsideSelected={selectedTab} />
      <Box sx={{ width: "100%", display: "flex", flexDirection: "row", gap: 2, pt: 2 }}>
        <TextField
          sx={{ width: "50%" }}
          label={selectedTab === MEAL ? "Meal Name" : "Activity Name"}
          value={eventName}
          onChange={e => onEventNameChange(e.currentTarget.value)}
        />
        {selectedTab === MEAL ? (
          <MealTypeSelect sx={{ width: "50%" }} value={mealType} onChange={onMealTypeChange} />
        ) : (
          <ActivityTypeSelect sx={{ width: "50%" }} value={activityType} onChange={onActivityTypeChange} />
        )}
      </Box>
      <Box sx={{ display: "flex", gap: 2, mt: 5, mb: 4 }}>
        <Controller
          control={control}
          name="start"
          render={({ field }) => (
            <DesktopTimePicker
              {...field}
              label="Start Time"
              slotProps={{
                textField: {
                  helperText: errors.start?.message,
                  error: Boolean(errors.start),
                },
              }}
            />
          )}
        />
        <Controller
          control={control}
          name="end"
          render={({ field }) => (
            <DesktopTimePicker
              {...field}
              label="End Time"
              slotProps={{
                textField: {
                  helperText: errors.end?.message,
                  error: Boolean(errors.end),
                },
              }}
            />
          )}
        />
      </Box>
    </Box>
  );
};
